import { createContext, useContext } from 'react';
import useMedia, { useMediaLayout } from 'use-media';

const createMediaQueryLookup = (mobileMax, tabletMax) => {
    return {
        mobile: `(max-width: ${mobileMax}px)`,
        tablet: `(min-width: ${mobileMax + 1}px) and (max-width: ${tabletMax}px)`,
        desktop: `(min-width: ${tabletMax + 1}px)`,
    };
};
const viewportMatchesMediaQuery = ({ device, serverRender = false }, mediaQueryListener, { mobileMax, tabletMax }) => {
    const mediaQueryLookup = createMediaQueryLookup(mobileMax, tabletMax);
    const devices = Array.isArray(device) ? device : [device];
    const mediaQuery = devices.map((item) => mediaQueryLookup[item]).join(',');
    const isMatched = mediaQueryListener(mediaQuery, serverRender);
    if (serverRender && typeof window === 'undefined') {
        return true;
    }
    return isMatched;
};
const ViewportContext = createContext({ mobileMax: 520, tabletMax: 991 });
const ViewportProvider = ViewportContext.Provider;
function useViewport({ device, serverRender }) {
    const { mobileMax, tabletMax } = useContext(ViewportContext);
    return viewportMatchesMediaQuery({ device, serverRender }, useMedia, {
        mobileMax,
        tabletMax,
    });
}
function useViewportLayout({ device, serverRender }) {
    const { mobileMax, tabletMax } = useContext(ViewportContext);
    const useIsomorphicMediaQueryListener = typeof window !== 'undefined' ? useMediaLayout : useMedia;
    return viewportMatchesMediaQuery({ device, serverRender }, useIsomorphicMediaQueryListener, {
        mobileMax,
        tabletMax,
    });
}

export { ViewportProvider, useViewport, useViewportLayout };
//# sourceMappingURL=useViewport.js.map
